import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { VNCustomerPayingWithCard } from '../components/VNCustomerPayingWithCard'
import { VNCustomerViewingReceiptDialog } from '../components/VNCustomerViewingReceiptDialog'
import { VNTransactionCompleteDialog } from '../components/VNTransactionCompleteDialog'
import { VNTransactionErrorDialog } from '../components/VNTransactionErrorDialog'
import { VNCustomerPaymentDialog } from '../components/VNCustomerPaymentDialog'
import { VNConfirmPaymentDialog } from '../components/VNConfirmPaymentDialog'
import { VNCustomerEnteringTipDialog } from '../components/VNCustomerEnteringTipDialog'

const useStyles = makeStyles(theme => ({
  
}))

export const VNDialogsContainer = () => {

  const classes = useStyles()

  const dispatch = useDispatch()

  return (
    <>
      <VNCustomerPayingWithCard />
      <VNCustomerViewingReceiptDialog />
      <VNTransactionCompleteDialog />
      <VNTransactionErrorDialog />
      <VNCustomerPaymentDialog />
      <VNConfirmPaymentDialog />
      <VNCustomerEnteringTipDialog />
    </>
  )
}
